import { render, staticRenderFns } from "./cell-user-info.vue?vue&type=template&id=2939eb5e&scoped=true"
import script from "./cell-user-info.ts?vue&type=script&lang=ts&external"
export * from "./cell-user-info.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-user-info.vue?vue&type=style&index=0&id=2939eb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2939eb5e",
  null
  
)

export default component.exports